import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Blog from '@/components/Blog'
import BlogDetails from '@/components/BlogDetails'
import News from '@/components/News'
import NewsDetails from '@/components/NewsDetails'
import Register from '@/components/Register'
import Charts from '@/components/Charts'
import Daily from '@/components/Daily'
import PageNotFound from '@/components/PageNotFound'
import About from '@/components/About'
import Resources from '@/components/Resources'
import DataRequest from '@/components/DataRequest'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/resources/:page',
      name: 'resources',
      component: Resources
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog
    },
    {
      path: '/blog/:id',
      name: 'blogdetails',
      component: BlogDetails
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/charts/daily',
      name : 'daily',
      component: Daily
    },
    {
      path: '/charts',
      name: 'charts',
      component: Charts
    },
    {
      path: '/page/:id',
      name: 'page',
      component: About
    },
     {
      path: '/request',
      name: 'request',
      component: DataRequest
    },
    {
      path: "*",
      component: PageNotFound
    }
  ]
  //mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js